export var HorizontalAlignments;

(function (HorizontalAlignments) {
  HorizontalAlignments["CENTER"] = "center";
  HorizontalAlignments["LEFT"] = "left";
  HorizontalAlignments["RIGHT"] = "right";
})(HorizontalAlignments || (HorizontalAlignments = {}));

export var VerticalAlignments;

(function (VerticalAlignments) {
  VerticalAlignments["BOTTOM"] = "bottom";
  VerticalAlignments["CENTER"] = "center";
  VerticalAlignments["TOP"] = "top";
})(VerticalAlignments || (VerticalAlignments = {}));